import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator(
  'large_group_custom_benefits_set', '/large_group_custom_benefits_sets', 'benefits_set'
)
const reducer = generator.generate()

export default reducer
